var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-full relative",on:{"click":function($event){$event.stopPropagation();}}},[(_vm.timelineData.length > 0)?_c('div',{staticClass:"w-full absolute bg-white top-100 z-500 border p-3 overflow-auto height",class:{ hidden: !_vm.activePoper }},[_c('vx-timeline',{attrs:{"data":_vm.timelineData}})],1):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }